import { Link as RouterLink } from 'react-router'

import { Box, BoxProps, Link, SimpleGrid } from '@chakra-ui/react'

import WWTLogoIcon from '@wwt/shared/assets/icons/logos/wwt-logo.svg'

import { Copyright } from './components/Copyright'
import { FooterColumn } from './components/FooterColumn/FooterColumn'
import { footerLinkKeys } from './components/FooterColumn/constants/footerLinks'

type FooterProps = BoxProps

// TODO: Rewrite Footer
export const Footer = (props: FooterProps) => {
	return (
		<Box
			as="footer"
			// FIXME: VStack in App.tsx breaks default block behavior (span to parent width)
			w="100%"
			pt={{ base: '2rem', md: '3.5rem', xl: '5rem' }}
			pb={{ base: '1.25rem', md: '1rem' }}
			bg="primary.100"
			{...props}
		>
			<div className="container">
				<Link
					as={RouterLink}
					to="/"
					data-wwt-id="footer__logo--link"
					display="block"
					w="fit-content"
					mb="2.5rem"
				>
					<WWTLogoIcon
						width="12.375rem"
						color="white"
					/>
				</Link>

				<SimpleGrid
					columns={{ base: 1, md: 2, xl: 4 }}
					spacing="2.5rem"
					mb="2.5rem"
				>
					{footerLinkKeys.map(column => (
						<FooterColumn
							title={column.title}
							links={column.links}
							key={column.title}
						/>
					))}
				</SimpleGrid>

				<Copyright />
			</div>
		</Box>
	)
}
